export default __webpack_public_path__ + "images/c778364fcea0984ec5e61133d21f9a74-services-info.svg";